module.exports = __webpack_public_path__ + "static/media/roomate_bg.23c36ab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/roomate_bg.png
// module id = 1153
// module chunks = 2